import { ActionIcon, Tooltip } from "@mantine/core";
import React, { forwardRef } from "react";
import { LuUnderline } from "react-icons/lu";

const TextUnderscore = ({ editor, language }) => {
  if (!editor) {
    return null;
  }

  const TooltipComponent = forwardRef((props, ref) => (
    <div ref={ref} {...props} style={{ pointerEvents: "none" }}>
      <LuUnderline />
    </div>
  ));

  return (
    <div className="control-group">
      <div className="button-group">
        <Tooltip
          classNames={{ tooltip: "tooltip-body" }}
          transitionProps={{ duration: 200 }}
          openDelay={500}
          multiline
          events={{ hover: true, focus: true, touch: true }}
          label={language.TextEditor.Underline}
        >
          <ActionIcon
            className="text-editor-button"
            type="button"
            size="md"
            w="40"
            variant={editor.isActive("underline") ? "light" : "subtle"}
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            color="black"
          >
            <TooltipComponent />
          </ActionIcon>
        </Tooltip>
      </div>
    </div>
  );
};

export default TextUnderscore;
